import styled, { css } from 'styled-components'

import AccountSettingsSvg from '../../../../img/account_menu_icons/account-settings.inline.svg'
import AutoShipSvg from '../../../../img/account_menu_icons/autoship.inline.svg'
import BillingShippingSvg from '../../../../img/account_menu_icons/billing-shipping.inline.svg'
import PacketsSvg from '../../../../img/account_menu_icons/cube.inline.svg'
import DashboardSvg from '../../../../img/account_menu_icons/dashboard.inline.svg'
import DnaIconSvg from '../../../../img/account_menu_icons/dna-icon.inline.svg'
import PurchasesSvg from '../../../../img/account_menu_icons/purchases.inline.svg'
import RewardsOrderHistorySvg from '../../../../img/account_menu_icons/rewards-order-history.inline.svg'
import VirtualDispensarySvg from '../../../../img/account_menu_icons/virtual-dispensary.inline.svg'
import WellWorldSvg from '../../../../img/account_menu_icons/well-world.inline.svg'

const iconStyles = css`
  display: inline-block;
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 15px;
  fill: currentColor;
`

const iconStyles2 = css`
  display: inline-block;
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 15px;
  fill: none;
`

export const AccountSettingsIcon = styled(AccountSettingsSvg)`
  ${iconStyles};
`

export const AutoShipIcon = styled(AutoShipSvg)`
  ${iconStyles};
  fill: ${({ theme }) => theme.colors.brand.orange};
`

export const BillingShippingIcon = styled(BillingShippingSvg)`
  ${iconStyles};
  fill: ${({ theme }) => theme.colors.brand.blue};
`

export const DashboardIcon = styled(DashboardSvg)`
  ${iconStyles};
  fill: ${({ theme }) => theme.colors.brand.blue};
`

export const GenomicsSpotlightIcon = styled(DnaIconSvg)`
  ${iconStyles2};
`

export const PacketsIcon = styled(PacketsSvg)`
  ${iconStyles2};
`

export const PurchasesIcon = styled(PurchasesSvg)`
  ${iconStyles2};
`

export const RewardsOrderHistoryIcon = styled(RewardsOrderHistorySvg)`
  ${iconStyles2};
`

export const VirtualDispensaryIcon = styled(VirtualDispensarySvg)`
  ${iconStyles2};
`

export const WellWorldIcon = styled(WellWorldSvg)`
  ${iconStyles};
`
